import DataDog from '../Helpers/DataDog';
import ApiService from './ApiService';

export const GuardarEventoProductoPremium = (evento) => {
    const { REACT_APP_APIPAYWALL } = process.env;

    return ApiService.post(`${REACT_APP_APIPAYWALL}EventosSuscripcionesV1/GuardarEventoProductoPremiumAdq`, evento)
        .then((data) => {
            if (data && data.code === '0000') {
                DataDog.trackCustomEvent('guardar-evento-alta-bonificado');
                return Promise.resolve(data);
            }else{
                DataDog.trackCustomEventWarning('error-guardarEvento-bonificado' , { error: data.message, code: data.code });
            }
        })
        .catch((error) => {
            DataDog.trackCustomEventWarning('error-guardarEvento-bonificado' , { error: error });
            return Promise.reject(error);
        });

};
